import { useCallback } from 'react';
import { Flex, Heading, Button } from '@kiwicom/account-components';
import { Illustration } from '@kiwicom/orbit-components';
import { useAuth } from '@kiwicom/nitro/lib/services/auth/context';
import { FormattedMessage } from 'react-intl';

type Props = {
  readonly error?: string;
};

const VerifyEmail = ({ error }: Props) => {
  const { onOpenModal } = useAuth();
  const handleOpenModal = useCallback(() => onOpenModal(), [onOpenModal]);

  if (error != null) {
    return (
      <Flex maxWidth="500px" margin="0 auto" alignItems="center" flexDirection="column">
        <Illustration spaceAfter="medium" name="AirHelp" size="small" />
        <Heading type="title2" as="h3" spaceAfter="large">
          <FormattedMessage id="account.invalid_email_verification_token" />
        </Heading>
        <Button type="primary" onClick={handleOpenModal}>
          <FormattedMessage id="account.magic_token_expired.button" defaultMessage="Try again" />
        </Button>
      </Flex>
    );
  }

  // user will never come to this
  return null;
};

export default VerifyEmail;
